import React from "react";
import { useNavigate } from "react-router-dom";
import "./footer.css";
import footerLogo    from "../../images/cloudisianIcon.png";
import salesforce    from "../../images/icons/salesforce.png";
import phonepe       from "../../images/icons/Phonepay.png";
import odoo          from "../../images/icons/odoo.png";

// ── DATA ────────────────────────────────────────────────────────
const FOOTER_COLS = [
  {
    heading: "Products",
    links: [
      { label: "Web Platforms",    href: "/product/productWeb1"    },
      { label: "AI & ML",          href: "/product/productMl1"     },
      { label: "Data Analytics",   href: "/product/productData1"   },
      { label: "Cybersecurity",    href: "/product/productCloud1"  },
      { label: "Mobile Apps",      href: "/product/productMobile1" },
    ],
  },
  {
    heading: "Services",
    links: [
      { label: "Mobile App Development", href: "/services/mobile-app-development" },
      { label: "Web Development",        href: "/services/web-development" },
      { label: "Cloud & Infrastructure", href: "/services/cloud-services" },
      { label: "AI & Data Analytics",    href: "/services/ai-data-analytics" },
      { label: "Cyber Security",         href: "/services/cyber-security" },
    ],
  },
  {
    heading: "Industries",
    links: [
      { label: "Banking & Finance", href: "/" },
      { label: "Healthcare",        href: "/" },
      { label: "Manufacturing",     href: "/" },
      { label: "Retail & E-Commerce", href: "/" },
      { label: "Education & EdTech",  href: "/" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About Us",       href: "/about"      },
      { label: "Careers",        href: "/careers"    },
      { label: "R&D",            href: "/research"   },
      { label: "White Papers",   href: "/whitepaper" },
      { label: "News & Insights",href: "/newslatter" },
      { label: "Contact Us",     href: "/contact"    },
    ],
  },
];

const PARTNERS = [
  { label: "Salesforce", img: salesforce, href: "https://www.salesforce.com/in/" },
  { label: "PhonePe",    img: phonepe,    href: "https://www.phonepe.com/"        },
  { label: "Odoo",       img: odoo,       href: "https://www.odoo.com/"           },
];

const LEGAL = [
  { label: "Privacy Policy",      href: "/policy" },
  { label: "Terms of Service",    href: "/terms"  },
  { label: "Refund Policy",       href: "/refund" },
];

// ── COMPONENT ───────────────────────────────────────────────────
const Footer = () => {
  const navigate = useNavigate();

  const go = (e, href) => {
    e.preventDefault();
    if (href.startsWith("http")) {
      window.open(href, "_blank", "noopener noreferrer");
    } else {
      navigate(href);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };


  return (
<footer className="cf">

      {/* ── TOP BAND ─────────────────────────────────────────── */}
      <div className="cf-top-band">
        <div className="cf-wrap">
          <div className="cf-top-inner">
            <div className="cf-top-left">
              <span className="cf-top-tag">✦ ISO 27001 Certified</span>
              <span className="cf-top-tag">ISO 9001 Certified</span>
              <span className="cf-top-tag">99% Uptime SLA</span>
            </div>
            <a
              className="cf-top-cta"
              href="/contact"
              onClick={(e) => go(e, "/contact")}
            >
              Schedule a Discovery Call ↗
            </a>
          </div>
        </div>
      </div>

      {/* ── MAIN BODY ────────────────────────────────────────── */}
      <div className="cf-body">
        <div className="cf-wrap">
          <div className="cf-grid">

            {/* Brand column */}
            <div className="cf-brand-col">
              {/* Logo */}
              <a
                href="/"
                className="cf-logo"
                onClick={(e) => go(e, "/")}
                aria-label="Cloudisian home"
              >
                <img src={footerLogo} alt="Cloudisian" />
              </a>

              <p className="cf-brand-desc">
                Intelligent, secure, and scalable technology solutions
                that power enterprise growth and digital resilience worldwide.
              </p>

              <a
                className="cf-email"
                href="mailto:info@cloudisian.net"
              >
                info@cloudisian.net
              </a>

              {/* Social */}
              {/* <div className="cf-social">
                {SOCIAL.map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    className="cf-social-btn"
                    aria-label={s.label}
                    onClick={(e) => go(e, s.href)}
                  >
                    <img src={s.icon} alt={s.label} />
                  </a>
                ))}
              </div> */}

              {/* Partners */}
              <div className="cf-partners">
                <p className="cf-partners-label">Our Partners</p>
                <div className="cf-partner-logos">
                  {PARTNERS.map((p) => (
                    <a
                      key={p.label}
                      href={p.href}
                      className="cf-partner-logo"
                      aria-label={p.label}
                      onClick={(e) => go(e, p.href)}
                      title={p.label}
                    >
                      <img src={p.img} alt={p.label} />
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Link columns */}
            {FOOTER_COLS.map((col) => (
              <div key={col.heading} className="cf-link-col">
                <h4 className="cf-col-head">{col.heading}</h4>
                <ul className="cf-link-list">
                  {col.links.map((lk) => (
                    <li key={lk.label}>
                      <a
                        href={lk.href}
                        className="cf-link"
                        onClick={(e) => go(e, lk.href)}
                      >
                        {lk.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

          </div>
        </div>
      </div>

      {/* ── BOTTOM BAR ───────────────────────────────────────── */}
      <div className="cf-bottom">
        <div className="cf-wrap">
          <div className="cf-bottom-inner">
            <p className="cf-copy">
              © {new Date().getFullYear()} Cloudisian Technologies Pvt. Ltd. All rights reserved.
            </p>
            <div className="cf-legal">
              {LEGAL.map((l, i) => (
                <React.Fragment key={l.label}>
                  {i > 0 && <span className="cf-legal-sep" aria-hidden="true">·</span>}
                  <a
                    href={l.href}
                    className="cf-legal-link"
                    onClick={(e) => go(e, l.href)}
                  >
                    {l.label}
                  </a>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
